document.addEventListener('DOMContentLoaded', function () {
    const readMoreBtns = document.querySelectorAll('.dealer-content__read-more');

    if (readMoreBtns){
        readMoreBtns.forEach(element => {
            element.addEventListener('click', function () {
                const parent = element.closest('.dealer-content__text');
                const fullText = parent.getAttribute('data-full-text');
                parent.innerHTML = fullText;
            });
        });
    }

    const userReviews = document.querySelectorAll('.dealer-reviews__list--item');

    if (userReviews) {
        userReviews.forEach(item => {
            item.addEventListener('click', function () {
                const userText = this.querySelector('.user-text');
                if (userText) {
                    userText.classList.toggle('user-text--expanded');
                }
            });
        });
    }
});